import React from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer';
import { TEACHER_USER_TYPE } from '../../services/UserService';
import { TeacherNavItems } from './TeacherNavItems';
import Syllabus from '../../Components/Syllabus/Syllabus';

const TeacherSyllabus = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar navItems={TeacherNavItems} user={TEACHER_USER_TYPE} />
            <Syllabus user={TEACHER_USER_TYPE} />
            <Footer user={TEACHER_USER_TYPE} />
        </div>
    )
}

export default TeacherSyllabus;